const CONTACT_OPTIONS = [
    { text: "Mobile Phone", value: "MOBILE_PHONE" },
    { text: "Alternate Phone", value: "ALTERNATE_PHONE" },
    { text: "Email", value: "EMAIL" },
]
export default CONTACT_OPTIONS;